class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this.details);
    });

    this.closeEsc = (e) => {
      if (
        e.key === "Escape" &&
        this.classList.contains("open") &&
        !this.querySelector(".mobile-menu__main-mega-menu.open")
      ) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.handleResize = () => {
      if (!this._isMobile && this.details.open) {
        this._forceClose();
      }

      this._setMaxHeightVariable();
    };

    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    window.removeEventListener("resize", this.handleResize);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _forceClose() {
    this.classList.remove("open");
    this.details.open = false;
    window.closeDimmer(this);
    window.removeTrapFocus(this.summary);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open() {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openDimmer(this);
      // this.querySelector(".mobile-search__query-input").focus();
      this.style.setProperty(
        "--mobile-menu-top",
        `${this.closest(".header").getBoundingClientRect().bottom}px`,
      );
      this._setMaxHeightVariable();
    });
    window.trapFocus(this.details);
  }

  _close() {
    this.classList.remove("open");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      window.unlockScroll(this);
      window.closeDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };
    this.addEventListener("transitionend", onEnd);
  }

  _setMaxHeightVariable() {
    const container = this.querySelector('.header__mobile-menu-content');
    const { height } = container.getBoundingClientRect();
    this.style.setProperty('--mobile-menu-max-content-height', `${height}px`);
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 959px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
